import React, { useEffect, useState, useRef } from 'react';
import { Link } from "react-router-dom";
import Monthly_navbar from './Monthlytasks_navbar';
import { Form } from "react-bootstrap";
import MonthsDropDown from '../Shared/MonthsDropDown';
import YearsDropDown from '../Shared/YearsDropDown';
import moment from "moment";
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { scrollToTop } from '../Shared/ScrollOnTop';
import config from '../../Config';
import FeePostingBusyOverlay from '../Shared/FeePostingBusyOverlay';

const FEE_POST_TIMEOUT_MS = 20 * 60 * 1000;

function getDefaultMonthValue() {
    return String(new Date().getMonth() + 1);
}

function getDefaultYearValue() {
    return moment().format('YYYY');
}

const StartNewMonth = () => {
document.title="Start New Month"
    const [Month, setMonth] = useState(getDefaultMonthValue);
    const [Year, setYear] = useState(getDefaultYearValue);
    const [MonthForConcessions, setMonthForConcessions] = useState(getDefaultMonthValue);
    const [YearForConcessions, setYearForConcessions] = useState(getDefaultYearValue);


    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [SessionID, setSessionID] = useState(localStorage.getItem("DefaultSession"));

    const [TransportFee, setTransportFee] = useState(false);

    const [busyMode, setBusyMode] = useState(null);
    const [busyTitle, setBusyTitle] = useState('');
    const [busyDetail, setBusyDetail] = useState('');
    const [elapsedSec, setElapsedSec] = useState(0);
    const busyTimerRef = useRef(null);

    const isBusy = busyMode !== null;

    const clearBusyTimer = () => {
        if (busyTimerRef.current) {
            clearInterval(busyTimerRef.current);
            busyTimerRef.current = null;
        }
    };

    const startBusyOverlay = (title, detail, mode) => {
        setBusyTitle(title);
        setBusyDetail(detail);
        setBusyMode(mode);
        setElapsedSec(0);
        clearBusyTimer();
        busyTimerRef.current = setInterval(() => setElapsedSec((n) => n + 1), 1000);
    };

    const stopBusyOverlay = () => {
        clearBusyTimer();
        setBusyMode(null);
        setElapsedSec(0);
    };

    useEffect(() => () => clearBusyTimer(), []);


    const handleMonth = () => {
        if (!Month || !Year || Month === '' || Year === '') {
            toast.error('Please select month and year.', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        const sm = parseInt(Month, 10);
        const fy = parseInt(Year, 10);
        if (!Number.isFinite(sm) || !Number.isFinite(fy) || sm < 1 || sm > 12) {
            toast.error('Invalid month or year.', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            SelectedMonth: sm,
            FYear: fy,
            SessionID: SessionID,
            AddTransportFee:TransportFee
        };
    
        startBusyOverlay(
            'Posting fees (student ledger)',
            'Posting monthly dues for all students. Large schools (about 6,000 students) can take several minutes. Please wait — do not close this tab.',
            'ledger'
        );
        const api_config = {
            method: 'post',
            url: config.base_url + '/api/FeeSystem/StartNewMonth',
            timeout: FEE_POST_TIMEOUT_MS,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };
    
        axios(api_config)
            .then(function (response) {
                if(response.data.status_code==1){
                    toast.success(response.data.status_Message || 'Month started successfully.', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
                else {
                    toast.error(response.data.status_Message || 'Request failed', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
            })
            .catch(function (error) {
                const msg = error.code === 'ECONNABORTED'
                    ? 'Request timed out. The server may still be processing — check results before retrying.'
                    : (error.response?.data?.status_Message || error.message || 'Network error.');
                toast.error(msg, {
                    position: toast.POSITION.TOP_RIGHT
                });
            })
            .finally(stopBusyOverlay);
    }



    const handleConcessions = ()=>{
        if (!MonthForConcessions || !YearForConcessions || MonthForConcessions === '' || YearForConcessions === '') {
            toast.error('Please select month and year for concessions.', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        const smc = parseInt(MonthForConcessions, 10);
        const fyc = parseInt(YearForConcessions, 10);
        if (!Number.isFinite(smc) || !Number.isFinite(fyc) || smc < 1 || smc > 12) {
            toast.error('Invalid month or year for concessions.', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            SelectedMonth: smc,
            FYear: fyc,
            SessionID: SessionID
        };
        startBusyOverlay(
            'Applying concessions',
            'Updating concession-related fee data on the server. This may take a while for many students.',
            'concession'
        );
        const api_config = {
            method: 'post',
             url: config.base_url + 'FeeSystem/ApplyConcession',
            timeout: FEE_POST_TIMEOUT_MS,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };
    
        axios(api_config)
            .then(function (response) {
                if(response.data.status_code==1){
                    toast.success(response.data.status_Message || 'Concessions applied.', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
                else {
                    toast.error(response.data.status_Message || 'Request failed', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
            })
            .catch(function (error) {
                const msg = error.code === 'ECONNABORTED'
                    ? 'Request timed out. Check whether the job completed before trying again.'
                    : 'Network Error..';
                toast.error(msg, {
                    position: toast.POSITION.TOP_RIGHT
                });
            })
            .finally(stopBusyOverlay);
    }












return (
    <>
        <FeePostingBusyOverlay
            show={isBusy}
            title={busyTitle}
            message={busyDetail}
            elapsedSeconds={elapsedSec}
        />
        <Monthly_navbar />
        <ToastContainer />
        <div className="page-head">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                                <li className="breadcrumb-item"><Link to="/MonthlyTasks/MonthlyTasksDashboard">Monthly Task</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Start New Month</li>
                            </ol>
                        </nav>
                        <div className="page-title">Start New Month</div>
                    </div>
                    <div className="col-md-6">
                        <div className="page-right-actions">
                            <Link to="/MonthlyTasks/ManageMonth" className="button button-white button-icon">
                                Manage Month
                                <i className="ri-list-check"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="page-content" ng-controller="MonthlyTasksController">
            <div className="container">
                <div className="card mb-2">
                    <div className="card-body p-md-4">
                        <div className="bg-light p-md-4">
                            <p className="mb-1">
                                Start New Month is a monthly task and will be perform to add dues in the students ledger, just verify the date and click on the button below, this will update the ledgers with current feeses mentioned as monthly fee in classes defination.
                            </p>
                            <h5><b>Note:</b></h5>
                            <p className="mb-0">A full-screen progress indicator appears while posting. For thousands of students this can take several minutes — do not press the button twice or close the tab.</p>
                        </div>

                    </div>
                </div>
            </div>
            <div className="container">
                <div className="card">
                    <div className="card-body p-md-4">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <div className="row align-items-center">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>Current Month</label>
                                            <select className="form-select"
                                             value={Month}
                                             onChange={(e) => setMonth(e.target.value)}
                                             disabled={isBusy}
                                            >
                                                <option value="">Please Select</option>
                                                <MonthsDropDown />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>
                                                Current Year
                                            </label>
                                            <select className="form-select"
                                            value={Year}
                                            onChange={(e) => setYear(e.target.value)}
                                            disabled={isBusy}
                                            >
                                                <option value="">Please Select</option>
                                                <YearsDropDown />

                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>
                                                Today
                                            </label>
                                            <input disabled className="form-control" value={moment().format('h:mm A')} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <Form.Group className="mt-4">
                                            <Form.Check
                                                required
                                                label="Add Transport Fee:"
                                                feedbackType="invalid"
                                                checked={TransportFee}
                                                disabled={isBusy}
                                                onChange={(e)=>setTransportFee(e.target.checked)}

                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-3 text-end">
                                        <button
                                            type="button"
                                            className="button button-primary d-inline-flex align-items-center justify-content-center gap-2"
                                            onClick={handleMonth}
                                            disabled={isBusy}
                                            style={{ paddingLeft: '28px', paddingRight: '28px', minWidth: '200px' }}
                                        >
                                            {busyMode === 'ledger' ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                                    Processing…
                                                </>
                                            ) : (
                                                'Start This Month'
                                            )}
                                        </button>
                                    </div>
                                    {/* <div className="col-md-12 mt-2">
                                            <h6><b>Posting Details:</b></h6>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>
                                                    Students With 500 Fine
                                                </label>
                                                <input disabled className="form-control" value=" postingDetails.StudentsWith500Fine" />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>
                                                    Students With 50 Fine
                                                </label>
                                                <input disabled className="form-control" value="postingDetails.StudentsWith50Fine" />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>
                                                    Unpaid in Last Month
                                                </label>
                                                <input disabled className="form-control" value="postingDetails.UnpaidInLastMonth" />
                                            </div>
                                        </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


















            <div className="container mt-2">
                <div className="card">
                    <div className="card-body p-md-4">
                        <div className="row align-items-center">
                            <div className="col-md-12 ">
                                <div className="row ">
                                    <div className="col-md-2">
                                        {/* <div className="form-group">
                                            <label>Current Month</label>
                                            <select className="form-select"
                                             onChange={(e) => setMonth(e.target.value)}
                                            >
                                                <option value="">Please Select</option>
                                                <MonthsDropDown />
                                            </select>
                                        </div> */}
                                    </div>
                                    <div className="col-md-2">
                                        {/* <div className="form-group">
                                            <label>
                                                Current Year
                                            </label>
                                            <select className="form-select"
                                            onChange={(e) => setYear(e.target.value)}
                                            >
                                                <option value="">Please Select</option>
                                                <YearsDropDown />

                                            </select>
                                        </div> */}
                                    </div>
                                    <div className="col-md-2">
                                        {/* <div className="form-group">
                                            <label>
                                                Today
                                            </label>
                                            <input disabled className="form-control" value={moment().format('h:mm A')} />
                                        </div> */}
                                    </div>
                                    <div className="col-md-3">
                                        {/* <Form.Group className="mt-4">
                                            <Form.Check
                                                required
                                                label="Add Transport Fee:"
                                                feedbackType="invalid"
                                                checked={TransportFee}
                                                onChange={(e)=>setTransportFee(e.target.checked)}

                                            />
                                        </Form.Group> */}
                                    </div>
                                    <div className="col-md-3 text-end ">
                                        <button type="button" className="button button-primary"  >Post Transport Fee </button>
                                    </div>
                               
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="container mt-2">
                <div className="card">
                    <div className="card-body p-md-4">
                        <div className="row align-items-center">
                            <div className="col-md-12 ">
                                <div className="row ">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>Current Month</label>
                                            <select className="form-select"
                                             value={MonthForConcessions}
                                             onChange={(e) => setMonthForConcessions(e.target.value)}
                                             disabled={isBusy}
                                            >
                                                <option value="">Please Select</option>
                                                <MonthsDropDown />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>
                                                Current Year
                                            </label>
                                            <select className="form-select"
                                            value={YearForConcessions}
                                            onChange={(e) => setYearForConcessions(e.target.value)}
                                            disabled={isBusy}
                                            >
                                                <option value="">Please Select</option>
                                                <YearsDropDown />

                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        
                                    </div>
                                    <div className="col-md-3">
                                      
                                    </div>
                                    <div className="col-md-3 text-end  ">
                                        <button
                                            type="button"
                                            className="button button-primary d-inline-flex align-items-center justify-content-center gap-2"
                                            onClick={handleConcessions}
                                            disabled={isBusy}
                                        >
                                            {busyMode === 'concession' ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                                    Processing…
                                                </>
                                            ) : (
                                                'Apply Concessions'
                                            )}
                                        </button>
                                    </div>
                               
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="container mt-2">
                <div className="card">
                    <div className="card-body p-md-4">
                        <div className="row align-items-center">
                            <div className="col-md-12 ">
                                <div className="row ">
                                    <div className="col-md-2">
                                        {/* <div className="form-group">
                                            <label>Current Month</label>
                                            <select className="form-select"
                                             onChange={(e) => setMonth(e.target.value)}
                                            >
                                                <option value="">Please Select</option>
                                                <MonthsDropDown />
                                            </select>
                                        </div> */}
                                    </div>
                                    <div className="col-md-2">
                                        {/* <div className="form-group">
                                            <label>
                                                Current Year
                                            </label>
                                            <select className="form-select"
                                            onChange={(e) => setYear(e.target.value)}
                                            >
                                                <option value="">Please Select</option>
                                                <YearsDropDown />

                                            </select>
                                        </div> */}
                                    </div>
                                    <div className="col-md-2">
                                        {/* <div className="form-group">
                                            <label>
                                                Today
                                            </label>
                                            <input disabled className="form-control" value={moment().format('h:mm A')} />
                                        </div> */}
                                    </div>
                                    <div className="col-md-3">
                                        {/* <Form.Group className="mt-4">
                                            <Form.Check
                                                required
                                                label="Add Transport Fee:"
                                                feedbackType="invalid"
                                                checked={TransportFee}
                                                onChange={(e)=>setTransportFee(e.target.checked)}

                                            />
                                        </Form.Group> */}
                                    </div>
                                    <div className="col-md-3 text-end ">
                                        <button type="button" className="button button-primary " style={{paddingLeft:"36px",paddingRight:"36px"}}>Delete Posting </button>
                                    </div>
                               
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>








        </div>


    </>
);
}

export default StartNewMonth;
